import { Button as VuiButton, Text } from '@village/ui';
import { Banner as BannerComponent } from 'components/banner';
import styled from 'styled-components';

const Banner = styled(BannerComponent)`
    background: #dceaef;
    border-radius: 8px;
`;

const Title = styled(Text)`
    font-weight: 700 !important;
    margin-bottom: 0.25rem;
`;

const Content = styled(Text)`
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
`;

const ButtonWrapper = styled.div`
    width: 75%;
    margin-top: 1rem;
`;

const Button = styled(VuiButton)`
    margin: 0 auto;
    background-color: transparent;
`;

export { Title, Content, ButtonWrapper, Button, Banner };
